import styled from "styled-components";
export const ToolGrid=styled.div`display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;max-width:1180px;margin:0 auto 28px;text-align:left;a{background:#fff;min-height:112px;}@media(max-width:900px){grid-template-columns:repeat(2,minmax(0,1fr))}@media(max-width:620px){grid-template-columns:1fr}`;

export const Section = styled.section`
  padding: 88px clamp(16px, 5vw, 72px);
  background: ${({ theme }) => theme.color.green};
  color: white;
  text-align: center;
  @media (max-width: 767px) { padding-top: 64px; padding-bottom: 64px; }
`;

export const Intro = styled.div`
  max-width: 820px;
  margin: 0 auto 36px;

  span {
    color: ${({ theme }) => theme.color.orange};
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h2 {
    margin: 10px 0 12px;
  }

  p {
    margin: 0;
    font-size: 18px;
  }
`;

export const Choices = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  max-width: 920px;
  margin: 0 auto 16px;

  @media (max-width: 720px) { grid-template-columns: 1fr; }
`;

export const Choice = styled.button`
  display:flex;align-items:center;gap:11px;min-height:58px;padding:9px 13px;border:1px solid rgba(255,255,255,.35);
  border-radius:16px;background:${({$active})=>$active?"#fff":"rgba(255,255,255,.09)"};
  color:${({$active,theme})=>$active?theme.color.green:"#fff"};font-weight:900;text-align:left;
  b{display:grid;place-items:center;flex:0 0 34px;width:34px;height:34px;border-radius:50%;background:${({$active,theme})=>$active?theme.color.orange:"rgba(255,255,255,.15)"};color:${({theme})=>theme.color.black};}
  span{font-size:14px;}
  &:focus-visible{outline:3px solid ${({theme})=>theme.color.orange};outline-offset:3px;}
`;

export const Stage = styled.div`
  max-width:920px;margin:0 auto 28px;text-align:left;scroll-margin-top:104px;
  &:focus{outline:none;}
  @media(min-width:721px){
    article{display:grid;grid-template-columns:minmax(0,.8fr) minmax(0,1.2fr);column-gap:30px;align-items:start;}
    article>p{grid-column:1;}
    article>div:last-child{grid-column:2;grid-row:1 / span 3;padding-top:0;}
  }
`;

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  min-height: 250px;
  padding: 26px;
  border: 1px solid ${({ $featured }) => $featured ? "rgba(255, 170, 0, 0.62)" : "rgba(255, 255, 255, 0.16)"};
  border-top-width: ${({ $featured }) => $featured ? "6px" : "1px"};
  border-radius: 22px;
  background: #fff;
  color: ${({ theme }) => theme.color.black};
  box-shadow: 0 18px 42px rgba(8, 30, 13, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  h3 {
    margin: 10px 0 9px;
    color: ${({ theme }) => theme.color.green};
    font-size: 25px;
  }

  p {
    margin: 0 0 20px;
    line-height: 1.55;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 24px 54px rgba(8, 30, 13, 0.26);
  }

`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  b {
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: ${({ theme }) => theme.color.green};
    color: #fff;
  }

  small {
    color: ${({ theme }) => theme.color.green};
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
`;

export const ToolList = styled.div`
  display: grid;
  gap: 8px;
  margin-top: auto;
  padding-top: 20px;
  @media(min-width:721px){padding-top:0;}
`;

export const ToolLink = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  img { flex: 0 0 40px; width:40px; height:40px; }
  min-height: 70px;
  padding: 12px 15px;
  border: 1px solid rgba(28, 93, 39, 0.18);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.72);
  color: ${({ theme }) => theme.color.green};
  text-decoration: none;

  div { display: grid; flex:1; min-width:0; gap: 3px; padding-right: 0; }
  strong { font-weight: 900; }
  small { color: #5d685f; font-size: 12px; line-height: 1.4; font-weight: 500; }
  span { flex: 0 0 auto; font-size: 20px; }
  &:hover { background: #fff; transform: translateX(2px); }
`;

export const Button = styled.a`
  display: inline-block;
  padding: 16px 26px;
  border-radius: 999px;
  background: ${({ theme }) => theme.color.orange};
  color: ${({ theme }) => theme.color.black};
  font-weight: 900;
  text-decoration: none;
  box-shadow: 0 9px 0 #cc8500;

  &:hover {
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(4px);
    box-shadow: 0 5px 0 #cc8500;
  }
`;

